import { Box, Typography } from "@mui/material";
import { Listing } from "../../../types";
import InfoCell from "../../../../common/components/ui-kit/info-cell";

export default function FinancialDetails({ listing }: { listing: Listing }) {
  return (
    <Box
      sx={(theme) => ({
        backgroundColor: theme.nawy.colors.semantic.layer.primary,
        p: theme.nawy.spacing.md,
        display: "flex",
        flexDirection: "column",
        gap: theme.nawy.spacing.lg,
        borderRadius: theme.nawy.radius.xl,
      })}
    >
      <Box
        sx={(theme) => ({
          display: "flex",
          flexDirection: "column",
          gap: theme.nawy.spacing.sm,
        })}
      >
        <Typography
          sx={(t) => t.nawy.typography.english.variants.body.md.semibold}
        >
          Financial details
        </Typography>
        <Box
          sx={(t) => ({
            display: "flex",
            flexWrap: "wrap",
            gap: t.nawy.spacing["2xl"],
          })}
        >
          <InfoCell
            title="Rental amount"
            description={
              listing.propertyRental.rentalPrice
                ? `${listing.propertyRental.rentalPrice?.toLocaleString()} EGP`
                : "N/A"
            }
          />
          <InfoCell
            title="Annual increase"
            description={
              listing.propertyRental.annualIncreasePercent
                ? `${listing.propertyRental.annualIncreasePercent?.toString()} %`
                : "N/A"
            }
          />
        </Box>
      </Box>
    </Box>
  );
}
